import { render, staticRenderFns } from "./AddressListRight.vue?vue&type=template&id=bd840860&scoped=true&"
import script from "./AddressListRight.vue?vue&type=script&lang=js&"
export * from "./AddressListRight.vue?vue&type=script&lang=js&"
import style0 from "./AddressListRight.vue?vue&type=style&index=0&id=bd840860&prod&lang=css&"
import style1 from "./AddressListRight.vue?vue&type=style&index=1&id=bd840860&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd840860",
  null
  
)

export default component.exports